import type { ReactNode } from "react";
import { EmptyState } from "@agentnative/ui";
import { useAuthStore } from "../stores/auth";

/**
 * Wraps a /admin/* route's content so a non-admin sees a clear, labeled
 * "forbidden" state instead of a route whose action buttons fail with a
 * raw PermissionDenied from the backend (authsvc.RequirePlatformAdmin,
 * migration 0015_add_platform_admin) the first time they're clicked.
 * AppLayout already hides the nav links to these routes for a
 * non-admin, but hiding a link doesn't stop someone navigating here
 * directly by URL -- this is that second layer, UX only (the backend
 * check is what actually matters for security; this never needs to be
 * bypass-proof).
 */
export function RequirePlatformAdmin({ children }: { children: ReactNode }) {
  const user = useAuthStore((s) => s.user);
  const initialized = useAuthStore((s) => s.initialized);

  if (!initialized) {
    return null;
  }

  if (!user?.isPlatformAdmin) {
    return (
      <EmptyState
        title="Platform admin required"
        description="This page is only available to Agent Native platform admins."
      />
    );
  }

  return <>{children}</>;
}
